<div class="filter-container">
  <ul class="filter">
    <li
      class="filter-item"
      *ngFor="let item of filterItems"
      (click)="handleFilter(item.value)"
      [ngClass]="{ 'active': filterValue === item.value }"
    >
      {{ item.title| translate }}
    </li>
  </ul>
</div>

<lin-chat-search (handleSearch)="handleSearch($event)"></lin-chat-search>

<cdk-virtual-scroll-viewport
  itemSize="72"
  class="chat-list"
  linScrollable
  (scrollPosition)="scrollHandler()"
  [ngClass]="{ 'with-loader': isLoading$ | async, 'admin-list': isAdmin && isShowAll }"
>
  <ng-container *ngIf="(chatList$ | async)?.length; else noChats">
    <ng-container *cdkVirtualFor="let chat of chatList$ | async; trackBy: trackById">
      <lin-chat [chat]="chat" [isActive]="selectedChatId === chat.id" [currentUser]="currentUser"></lin-chat>
    </ng-container>
  </ng-container>

  <div *ngIf="isLoading$ | async;" class="chat-list-loader">
    <mat-spinner strokeWidth="2" diameter="30" color="accent"></mat-spinner>
  </div>
</cdk-virtual-scroll-viewport>
<div *ngIf="isAdmin && isShowAll" class="show-all-chats">
  <button mat-raised-button color="accent" class="btn btn-primary" (click)="handleLoadAllChats()">
    {{ (isAllForAdmin ? 'CLIENT.MESSENGER.CHAT_LIST.SHOW_MY' : 'CLIENT.MESSENGER.CHAT_LIST.SHOW_ALL') | translate }}
  </button>
</div>
<ng-template #noChats>
  <div class="chat-list empty" *ngIf="(isLoading$ | async) === false" [ngClass]="{ 'with-loader': isLoading$ | async }">
    {{ 'CLIENT.MESSENGER.CHAT_LIST.NO_CHATS' | translate }}
  </div>
</ng-template>
